// @ts-check
/**
 * Typed client for the quality patient-list API.
 *
 *   GET  /api/quality/patient-list/filters/ — dropdown values, routing tier counts
 *   POST /api/quality/patient-list/         — paginated patient rows with gap aggregates
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {import('./schema').operations} Operations */

/** @typedef {Schemas['QualityFilterOptionsResponse']} QualityFilterOptionsResponse */
/** @typedef {Schemas['QualityPatientListRequest']} QualityPatientListRequest */

/**
 * GET /api/quality/patient-list/filters/
 * @returns {Promise<QualityFilterOptionsResponse>}
 */
export async function getFilterOptions() {
  const { data } = await axios.get('/api/quality/patient-list/filters/')
  return data
}

/**
 * POST /api/quality/patient-list/
 * @param {Partial<QualityPatientListRequest>} params
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<{success: boolean, rowData: object[], lastRow: number, stats: {totalPatients: number, openGaps: number, overdueGaps: number}}>}
 */
export async function getPatientList(params, config) {
  const { data } = await axios.post('/api/quality/patient-list/', params, config)
  return data
}
